export enum FormInstanceOperationsEnum {
    OPEN = "formOpen",
    CLOSE = "formClose",
    SAVE = "formSave",
    SAVE_WITH_TRANSITION = "formSaveWithTransition"
}
